import { defineElement, html, TemplateElement, unsafeHTML } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-data-table/e-banking-data-table.js';
import { mapNodes } from "@/mgnl/utils/magnolia.js";

class EditableDataTable extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    get rows() {
        const rows = mapNodes(this.content.rows) || [];
        return rows.map((item) => ({ accountType: item.accountType, rate: item.rate,  limit: item.limit, limitAbove: item.limitAbove }));
    }

    template() {
        return html`
            <mb-e-banking-data-table
                .sectionHeadline="${this.content.sectionHeadline}"
                .headline="${this.content.headline}"
                .currency="${this.content.currency}"
                .accountType="${this.content.accountType}"
                .limit="${this.content.limit}"
                .rate="${this.content.rate}"
                .rows="${this.rows}"
                .legal="${this.content.legal}"
            ></mb-e-banking-data-table>
        `;
    }
}

defineElement('editable-data-table', EditableDataTable);
